import { BASE_URL } from 'common/config.js'
import { clearQueryAfterAuth } from 'common/functions.js'

export function processSlugAuth({ router, urlPath }) {
  const url = urlPath.replace(BASE_URL, '')
  const route = router.resolve(decodeURIComponent(url))

  const params = {}
  const query = clearQueryAfterAuth(route.query, [])

  return { name: 'Home', query, params }
}
